
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TablaTD3 from './TablaDT3'
import TablaTD2 from './TablaDT2'



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        maxWidth: 752,
    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
}));





export default function InteractiveList() {
    
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <FormGroup row>

            </FormGroup>
            <Grid container spacing={2}>
                {/* cupos */}
                <Grid item xs={12} md={6}>
                <Typography style={{marginTop:'-10px', textAlign:'center' , background:'#910434', color:'white', marginBottom:'1.5px' }} variant="h5" className={classes.title}>
                            {sessionStorage['ps_nombre']}
                </Typography>
                 
                        <TablaTD2/>
                
                </Grid>

                {/* ASIGNACIONES */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h6" className={classes.title}>
                        Asignaciones 
                    </Typography>
                    <div className={classes.demo}>
                            <TablaTD3/> 
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}
